import UtilisateurError from '../enums/UtilisateurError';
import type Collectivite from '../interfaces/collectivite';
import type { UtilisateurCollectiviteToCreate } from '../interfaces/utilisateurCollectivite';

export interface StepValidationResult {
	error: string | null;
	validated: boolean;
	updating?: boolean;
}

const error = 'Certains champs sont obligatoires.';

export const validateStepUser = (
	newUser: Partial<UtilisateurCollectiviteToCreate>,
	setError: (error: UtilisateurError[]) => void,
	isAgentActe: boolean,
	isAgentTeletransmetteur: boolean,
	isSignataireParapheur: boolean,
) => {
	const result: StepValidationResult = { error: null, validated: false };
	const errors: UtilisateurError[] = [];

	if (!newUser.email) {
		errors.push(UtilisateurError.EMAIL);
	} else {
		// Validation du format de l'email
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!emailRegex.test(newUser.email)) {
			errors.push(UtilisateurError.EMAIL_FORMAT);
		}
	}
	if (!newUser.nom) {
		errors.push(UtilisateurError.NOM);
	}
	if (!newUser.prenom) {
		errors.push(UtilisateurError.PRENOM);
	}

	if (isSignataireParapheur) {
		if (!newUser.codePostal) {
			errors.push(UtilisateurError.CODE_POSTAL);
		}
		if (!newUser.ville) {
			errors.push(UtilisateurError.VILLE);
		}
		if (!newUser.qualite) {
			errors.push(UtilisateurError.QUALITE);
		}
	}

	if (!isSignataireParapheur && !isAgentActe && !isAgentTeletransmetteur) {
		errors.push(UtilisateurError.ROLE);
	}
	setError(errors);

	if (errors.length > 0) {
		result.error = error;
		return result;
	}

	result.validated = true;
	return result;
};

export const validateStepTeletransmission = (
	certificatFile: File | null,
	hasSlow: boolean,
	setError: (error: UtilisateurError[]) => void,
): StepValidationResult => {
	const result: StepValidationResult = { error: null, validated: false };
	const errors: UtilisateurError[] = [];

	if (!certificatFile) {
		errors.push(UtilisateurError.CERTIFICAT);
	}

	if (!hasSlow) {
		errors.push(UtilisateurError.COLLECTIVITE_SLOW);
	}

	setError(errors);

	if (errors.length > 0) {
		result.error = error;
		return result;
	}

	result.validated = true;
	return result;
};

export const validateStepParapheur = (
	collectivites: Collectivite[],
	setError: (error: UtilisateurError[]) => void,
): StepValidationResult => {
	// Si on a un bureau sélectionné, on valide
	const isAnySelected = collectivites.some((col: Collectivite) =>
		Object.values(col).some(
			(bureauxEntite) =>
				Array.isArray(bureauxEntite) && bureauxEntite.some((b) => b.isSelected),
		),
	);

	if (!isAnySelected) {
		setError([UtilisateurError.BUREAUX]);
		return { error, validated: false };
	}
	return { error: null, validated: true };
};
